module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/arrow_left.svg?17bf71d14a6c7aece8252ebc639b4119";